import { IAuthorizationInitialState } from './types';

const initialState: IAuthorizationInitialState = {
	isAuth: false,
};

export default initialState;